module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAvCAMAAADHPVqlAAAATlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////+QlxstAAAAGXRSTlMAzA1wBP1nWefXQzHIYU05Ce/23MHRVCkSsJPhngAAALlJREFUOMvt09sKwyAMBuDa2Vpbjz3Y5f1fdDBYgnHxfrBc+pFofnB4lx46VUbZolOSar8ASBotgKCjuQAk9RlA1A2go4+//rga0qPBG22yjPS8Iy4rw9VinwupotGjwbWxvpBpptEV6eCmj528zyNBDsyiwrecaz0zzQstH/kOZNakus8ovNDdPFDKZS98pqO3RJ5n7uWJpkqq6NnL0+8sT/6zKU9es5Qn6eSCHiSlPFs9KM9Wt6/HL/6vKTJjzS+3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/subscribe/arrow.png
// module id = 2phN
// module chunks = 1